// NPM imports

import moment from 'moment';

// Project imports

import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { luftGet, luftPost, luftPut, luftDelete } from '../shared/http';

// actions

const REQUEST_COMPANIES = 'luft/admin-companies/REQUEST_COMPANIES';
const REQUEST_COMPANIES_SUCCESS =
  'luft/admin-companies/REQUEST_COMPANIES_SUCCESS';
const REQUEST_COMPANIES_FAILURE =
  'luft/admin-companies/REQUEST_COMPANIES_FAILURE';

const ADD_COMPANY = 'luft/admin-companies/ADD_COMPANY';
const ADD_COMPANY_SUCCESS = 'luft/admin-companies/ADD_COMPANY_SUCCESS';
const ADD_COMPANY_FAILURE = 'luft/admin-companies/ADD_COMPANY_FAILURE';
const ADD_COMPANY_CLEAR = 'luft/admin-companies/ADD_COMPANY_CLEAR';

const UPDATE_COMPANY = 'luft/admin-companies/UPDATE_COMPANY';
const UPDATE_COMPANY_SUCCESS = 'luft/admin-companies/UPDATE_COMPANY_SUCCESS';
const UPDATE_COMPANY_FAILURE = 'luft/admin-companies/UPDATE_COMPANY_FAILURE';
const UPDATE_COMPANY_CLEAR = 'luft/admin-companies/UPDATE_COMPANY_CLEAR';

const REMOVE_COMPANY = 'luft/admin-companies/REMOVE_COMPANY';
const REMOVE_COMPANY_SUCCESS = 'luft/admin-companies/REMOVE_COMPANY_SUCCESS';
const REMOVE_COMPANY_FAILURE = 'luft/admin-companies/REMOVE_COMPANY_FAILURE';
const REMOVE_COMPANY_CLEAR = 'luft/admin-companies/REMOVE_COMPANY_CLEAR';

// reducer

const initialState = {
  companies: {
    isFetching: false,
    error: '',
    requested: '',
    data: [],
  },
  addCompany: {
    isFetching: false,
    error: '',
    requested: '',
  },
  updateCompany: {
    isFetching: false,
    error: '',
    requested: '',
  },
  removeCompany: {
    isFetching: false,
    error: '',
    requested: '',
  },
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_COMPANIES: {
      return {
        ...state,
        companies: {
          ...state.companies,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }
    
    case REQUEST_COMPANIES_SUCCESS: {
      return {
        ...state,
        companies: {
          ...state.companies,
          isFetching: false,
          error: '',
          data: action.data,
        },
      };
    }

    case REQUEST_COMPANIES_FAILURE:
      return {
        ...state,
        companies: {
          ...state.companies,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_COMPANY: {
      return {
        ...state,
        addCompany: {
          ...state.addCompany,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case ADD_COMPANY_SUCCESS: {
      return {
        ...state,
        addCompany: {
          ...state.addCompany,
          isFetching: false,
          error: '',
        },
      };
    }

    case ADD_COMPANY_FAILURE:
      return {
        ...state,
        addCompany: {
          ...state.addCompany,
          isFetching: false,
          error: action.error,
        },
      };

    case ADD_COMPANY_CLEAR:
      return {
        ...state,
        addCompany: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case UPDATE_COMPANY: {
      return {
        ...state,
        updateCompany: {
          ...state.updateCompany,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case UPDATE_COMPANY_SUCCESS: {
      return {
        ...state,
        updateCompany: {
          ...state.updateCompany,
          isFetching: false,
          error: '',
        },
      };
    }

    case UPDATE_COMPANY_FAILURE:
      return {
        ...state,
        updateCompany: {
          ...state.updateCompany,
          isFetching: false,
          error: action.error,
        },
      };

    case UPDATE_COMPANY_CLEAR:
      return {
        ...state,
        updateCompany: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    case REMOVE_COMPANY: {
      return {
        ...state,
        removeCompany: {
          ...state.removeCompany,
          requested: moment().format('YYYY-MM-DD HH:mm:ss'),
          isFetching: true,
          error: '',
        },
      };
    }

    case REMOVE_COMPANY_SUCCESS: {
      return {
        ...state,
        removeCompany: {
          ...state.removeCompany,
          isFetching: false,
          error: '',
        },
        companies: {
          ...state.companies,
          data: state.companies.data.filter(el => el.id !== action.data.id),
        },
      };
    }

    case REMOVE_COMPANY_FAILURE:
      return {
        ...state,
        removeCompany: {
          ...state.removeCompany,
          isFetching: false,
          error: action.error,
        },
      };

    case REMOVE_COMPANY_CLEAR:
      return {
        ...state,
        removeCompany: {
          requested: '',
          isFetching: false,
          error: '',
        },
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators
// list
function requestCompanies() {
  return { type: REQUEST_COMPANIES };
}

function requestCompaniesSuccess(data) {
  return {
    type: REQUEST_COMPANIES_SUCCESS,
    data,
  };
}

function requestCompaniesFailure(error) {
  return {
    type: REQUEST_COMPANIES_FAILURE,
    error,
  };
}

// add
function addCompany() {
  return { type: ADD_COMPANY };
}

function addCompanySuccess(data) {
  return {
    type: ADD_COMPANY_SUCCESS,
    data,
  };
}

function addCompanyFailure(error) {
  return {
    type: ADD_COMPANY_FAILURE,
    error,
  };
}

export function addCompanyClear() {
  return { type: ADD_COMPANY_CLEAR };
}

// update
function updateCompany() {
  return { type: UPDATE_COMPANY };
}

function updateCompanySuccess(data) {
  return {
    type: UPDATE_COMPANY_SUCCESS,
    data,
  };
}

function updateCompanyFailure(error) {
  return {
    type: UPDATE_COMPANY_FAILURE,
    error,
  };
}

export function updateCompanyClear() {
  return { type: UPDATE_COMPANY_CLEAR };
}

// remove
function removeCompany() {
  return { type: REMOVE_COMPANY };
}

function removeCompanySuccess(data) {
  return {
    type: REMOVE_COMPANY_SUCCESS,
    data,
  };
}

function removeCompanyFailure(error) {
  return {
    type: REMOVE_COMPANY_FAILURE,
    error,
  };
}

export function removeCompanyClear() {
  return { type: REMOVE_COMPANY_CLEAR };
}

// thunk action creators
export function fetchCompanies(query, divisions = null) {
  return function (dispatch) {
    (async () => {
      dispatch(requestCompanies());
      const params = query ? { query } : null;
      const url = divisions ? `/Company/${divisions}` : '/Company';

      try {
        const response = await luftGet(url, params);
  
        dispatch(requestCompaniesSuccess(response.data));
      } catch (error) {
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          requestCompaniesFailure(error.message),
        );
      }
    })();
  };
}

export function fetchAddCompany(
  corporateName,
  cnpjList,
  luftBranch,
  logoFile,
  divisions,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(addCompany());

      const formData = new FormData();
      formData.append('companyLogoFile', logoFile);
      formData.append('name', corporateName);
      formData.append('corporateName', corporateName);

      cnpjList.forEach(el => {
        formData.append('cnpj[]', el.cnpj);
      });

      formData.append('division', luftBranch);
      formData.append('divisions', divisions);

      try {
        const response = await luftPost('/Company', formData, true);
        dispatch(addCompanySuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          addCompanyFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchUpdateCompany(
  id,
  corporateName,
  cnpjList,
  luftBranch,
  logoFile,
  divisions,
) {
  return function (dispatch) {
    return (async () => {
      dispatch(updateCompany());

      const formData = new FormData();
      formData.append('id', id);
      formData.append('companyLogoFile', logoFile);
      formData.append('updateLogo', logoFile !== '');
      formData.append('name', corporateName);
      formData.append('corporateName', corporateName);

      let count = 0;
      cnpjList.forEach(cnpj => {
        Object.keys(cnpj).forEach(key => {
          formData.append(`companyCNPJ[${count}].${key}`, cnpj[key]);
        });
        count += 1;
      });

      formData.append('division', luftBranch);
      formData.append('divisions', divisions);

      try {
        const response = await luftPut('/Company', formData, true);
        dispatch(updateCompanySuccess(response.data));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          updateCompanyFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}

export function fetchRemoveCompany(id) {
  return function (dispatch) {
    return (async () => {
      dispatch(removeCompany());

      const params = {
        id,
      };

      try {
        await luftDelete('/Company', params);
        dispatch(removeCompanySuccess(params));
        return true;
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          removeCompanyFailure(error.message),
        );
        throw new Error(error.message);
      }
    })();
  };
}
